import { render, staticRenderFns } from "./bonusActivity.vue?vue&type=template&id=4aa1be7a&"
import script from "./bonusActivity.vue?vue&type=script&lang=js&"
export * from "./bonusActivity.vue?vue&type=script&lang=js&"
import style0 from "./bonusActivity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports